import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  GetCompany,
  ActiveCompany,
  InactiveCompany,
} from "../../../store/company-store/company-actions";
import Loading from "../../../components/UI/Loading";

const CompanyDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const company = useSelector((state) => state.company.company);
  const auth = useSelector((state) => state.auth);
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (company.id !== undefined || company.id !== 0) {
      dispatch(GetCompany(param.companyId, auth.UserInfo.email));
    }
  }, [param.companyId, auth, dispatch, company.id]);

  const activeHandler = () => {
    dispatch(ActiveCompany(param.companyId, auth.UserInfo.email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveCompany(param.companyId, auth.UserInfo.email));
  };
  let activeSuspend;
  if (auth.roles !== undefined && auth.roles.includes("company.active")) {
    activeSuspend = (
      <Button
        rounded
        text
        raised
        style={{ backgroundColor: "#fff", marginLeft: "1%" }}
        label="Activar"
        className="p-button-success"
        onClick={activeHandler}
        icon={
          notification && notification.status === "pending"
            ? "pi pi-spin pi-spinner"
            : "pi pi-check"
        }
        disabled={notification && notification.status === "pending"}
      />
    );
  }
  if (company.status) {
    if (auth.roles !== undefined && auth.roles.includes("company.inactive")) {
      activeSuspend = (
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", marginLeft: "1%" }}
          label="Suspender"
          className="p-button-warning"
          onClick={inactiveHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-times"
          }
          disabled={notification && notification.status === "pending"}
        />
      );
    }
  }

  return (
    <>
      {(company.id === undefined || company.id <= 0) && (
        <>
          <Loading visible={true} />
        </>
      )}
      {(company.id !== undefined || company.id > 0) && (
        <Card
          style={{
            backgroundColor: "#183462",
            marginLeft: "0%",
            marginTop: "8px",
            boxShadow: "none",
            width: "98%",
            border: "solid #326fd1",
          }}
        >
          <div
            className="user-info text-center"
            style={{ borderBottom: "solid #fff", paddingBottom: "4px" }}
          >
            <h2
              id="header"
              className="mb-2"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              {company.name.toUpperCase()}
            </h2>
            <span
              className="badge bg-label-secondary"
              style={{
                fontSize: "large",
                color: "lightskyblue",
                fontWeight: "bold",
              }}
            >
              Empresa
            </span>
          </div>
          <div className="formgrid grid mt-3">
            <div className="field col-12 md:col-3">
              <>
                <label style={{ color: "#fff", fontSize: "large" }}>
                  RNC:{" "}
                </label>
                <label
                  style={{
                    color: "lightskyblue",
                    marginLeft: "1%",
                    fontSize: "large",
                  }}
                >
                  {" "}
                  {company.rnc}
                </label>
              </>
            </div>
            <div className="field col-12 md:col-12 mt-3">
              <Button
                rounded
                text
                raised
                style={{ backgroundColor: "#fff" }}
                label="Regresar"
                icon="pi pi-arrow-left"
                className="p-button-danger"
                onClick={() => {
                  navigate("/companies");
                }}
              />
              {auth.roles !== undefined &&
                auth.roles.includes("company.edit") && (
                  <Button
                    rounded
                    text
                    raised
                    style={{ backgroundColor: "#fff", marginLeft: "1%" }}
                    label="Editar"
                    icon="pi pi-file-edit"
                    className="p-button-primary"
                    onClick={() => {
                      navigate(`/company/edit/${param.companyId}`);
                    }}
                  />
                )}
              {activeSuspend}
            </div>
          </div>
        </Card>
      )}
    </>
  );
};
export default CompanyDetail;
